import React from 'react';
import { AnalyticsData } from '../../../../hooks/useBoardAnalytics';

interface UpcomingActivitiesListProps {
  activities: AnalyticsData['upcoming_activities'];
}

function formatDate(iso: string | null): string {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  } catch {
    return iso;
  }
}

export default function UpcomingActivitiesList({ activities }: UpcomingActivitiesListProps) {
  return (
    <div className="metrics-card">
      <div className="metrics-card__header">
        <span className="metrics-card__title">Upcoming Activities</span>
        <span style={{ fontSize: 12, color: '#9ca3af' }}>Next 7 days</span>
      </div>
      {activities.length === 0 ? (
        <div className="metrics-empty" style={{ padding: '24px 0' }}>No upcoming activities</div>
      ) : (
        <div className="upcoming-list">
          {activities.map((act) => (
            <div key={act.uid} className="upcoming-item">
              <span className="upcoming-item__type-badge">{act.type?.replace(/_/g, ' ')}</span>
              <div className="upcoming-item__content">
                <div className="upcoming-item__title">{act.title}</div>
                {(act.company_name || act.job_title) && (
                  <div className="upcoming-item__meta">
                    {[act.company_name, act.job_title].filter(Boolean).join(' · ')}
                  </div>
                )}
              </div>
              <div className="upcoming-item__date">{formatDate(act.start_date)}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
